<script setup lang="ts">
import { computed } from 'vue';
import GenericModal from '../modals/GenericModal.vue';

interface Props {
  modelValue: boolean;
  message: string;
  title: string;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  'update:modelValue': [value: boolean];
}>();

const show = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
});
</script>

<template>
  <GenericModal
    v-model="show"
    size="sm"
    :title="title"
    container-class="bg-background border border-muted"
    title-class="w-full text-center"
    title-class-container="w-full justify-center"
    :close-on-click-outside="true"
  >
    <div
      data-testid="cando-modal"
      class="rounded-xl border border-red-500/10 bg-red-500/5 p-4"
    >
      <p>{{ message }}</p>
    </div>
  </GenericModal>
</template>

<style scoped></style>
